import { useEffect } from 'react';
import { initVisitor } from '@meiqia/utils';

function useSocketEventOn(props) {
  const {
    im,
    onVisitorCome,
    onVisitorOffline,
    onEndConversation,
    onInviteVisitor,
    onRejectInvite,
    onAcceptInvite,
    changeInviteStatus,
    updateVisitorStatus
  } = props;

  const handleVisitorCome = stream => {
    if (stream && stream.length > 0) {
      const newVisits = stream.filter(val => val?.body?.track_id).map(val => initVisitor(val.body));
      if (newVisits?.length) {
        onVisitorCome(newVisits);
      }
    }
  };

  const handleVisitorOffline = stream => {
    if (stream && stream.length > 0) {
      onVisitorOffline(stream);
    }
  };

  const handleEndConversation = stream => {
    const trackId = stream?.track_id;
    if (trackId) {
      setTimeout(() => {
        onEndConversation(stream);
      });
    }
  };

  const handleAgentInvite = stream => {
    const trackId = stream?.track_id;
    if (trackId) {
      onInviteVisitor(stream);
    }
  };

  const handleRejectInvite = stream => {
    const trackId = stream?.track_id;
    if (trackId) {
      onRejectInvite(stream);
    }
  };

  const handleAcceptInvite = stream => {
    const trackId = stream?.track_id;
    if (trackId) {
      onAcceptInvite(stream);
    }
  };

  const handleInviteStatus = stream => {
    const trackId = stream?.track_id;
    if (trackId) {
      changeInviteStatus(stream);
    }
  };

  const handleUpdateVisitorStatus = stream => {
    const trackId = stream?.track_id;
    if (trackId) {
      updateVisitorStatus(stream);
    }
  };

  useEffect(() => {
    // 访客的上线与下线
    im.on('visitorCome', handleVisitorCome);
    im.on('offline', handleVisitorOffline);
    // 访客状态相关
    im.on('endConversation', handleEndConversation);
    im.on('agentInvite', handleAgentInvite);
    im.on('rejectInvite', handleRejectInvite);
    im.on('acceptInvite', handleAcceptInvite);
    im.on('changeInviteStatus', handleInviteStatus);
    im.on('updateVisitorStatus', handleUpdateVisitorStatus);

    return () => {
      im.off('visitorCome', handleVisitorCome);
      im.off('offline', handleVisitorOffline);
      im.off('endConversation', handleEndConversation);
      im.off('agentInvite', handleAgentInvite);
      im.off('rejectInvite', handleRejectInvite);
      im.off('acceptInvite', handleAcceptInvite);
      im.off('changeInviteStatus', handleInviteStatus);
      im.off('updateVisitorStatus', handleUpdateVisitorStatus);
    };
  }, []);
}

export default useSocketEventOn;
